(function(){
  var P = GP.productos, IX = GP.ix, esc = GP.esc, clp = GP.fmt, foto = GP.foto, url = GP.url, $ = GP.$;
  /* Si el producto todavía no está en la foto del catálogo, se usa el que entrega la
     plantilla (GP.productoActual). Antes se caía en el primer producto con imagen y la
     ficha mostraba otro perfume, con otro precio. */
  var p = P.filter(function (x) { return x.h === (GP.handleActual || ''); })[0] || GP.productoActual;
  if (!p) { return; }
  if (P.indexOf(p) < 0) { P.push(p); if (GP.ix) { GP.ix[p.i] = p; } }   // GP.ix es id → producto
  var e = GP.equiv(p);
  var notas = GP.notasDe(p);
  document.title = p.n + ' — Gold Perfumes';
  GP.verReciente(p.i);

  var ruta = [['/','Inicio'],['/collections/catalogo','Catálogo']];
  if (p.k==='arabe') ruta.push(['/collections/perfumes-arabes','Árabes']);
  else if (p.k==='nicho') ruta.push(['/collections/nicho','Nicho']);
  else if (p.k==='disenador') ruta.push(['/collections/disenador','Diseñador']);
  if (p.b) ruta.push([GP.T({m:p.b}), p.b]);
  $('#miga').innerHTML = ruta.map(function(r){return '<a href="'+r[0]+'">'+esc(r[1])+'</a>';}).join('<span>/</span>');

  /* ---------- barra de envío gratis ---------- */
  var falta = GP.UMBRAL - p.p;
  var sug = falta > 0 ? GP.sugerirEnvio(p.p, [p.i], 3) : [];
  var sumaSug = sug.reduce(function(s,x){return s+x.p;},0);
  var envioHTML = '';
  if (falta <= 0){
    envioHTML = '<div class="envio"><div class="envio__top">'+
      '<p class="envio__txt" style="margin:0"><b>Envío gratis</b> a todo Chile con este producto. RM entre 24 y 72 horas.</p></div></div>';
  } else if (sug.length && (p.p + sumaSug) >= GP.UMBRAL){
    envioHTML = '<div class="envio"><div class="envio__top">'+
        '<p class="envio__txt">Te faltan <b>'+clp(falta)+'</b> para el envío gratis. '+
        (sug.length===1 ? 'Con este producto lo consigues:' : 'Con estos '+sug.length+' lo consigues:')+'</p>'+
        '<div class="prog__barra"><i style="width:'+Math.round(100*p.p/GP.UMBRAL)+'%"></i></div></div>'+
      '<div class="envio__sug">'+ sug.map(function(s){
        return '<a class="envio__it" href="'+url(s)+'"><img src="'+foto(s)+'" alt="">'+
          '<span><strong>'+esc(s.n)+'</strong><span>'+esc(GP.meta(s))+'</span></span><b>'+clp(s.p)+'</b></a>';
      }).join('') +'</div>'+
      '<div class="envio__cta"><button class="btn btn--linea btn--bloque btn--sm" type="button" id="sumarEnvio">'+
        'Agregar los '+(sug.length+1)+' y llevar envío gratis · '+clp(p.p+sumaSug)+'</button></div></div>';
  }

  /* ---------- comparador ---------- */
  var WAENC = 'https://api.whatsapp.com/send/?phone=' +
    ((window.GP && GP.ajustes && GP.ajustes.wa) || '56965529189') + '&text=' +
    encodeURIComponent('Hola, ¿pueden conseguir ' + (p.ins || p.n) + '? Lo vi en la ficha de ' + p.n + '.');
  var compHTML = '';
  if (e){
    var o = e.o;
    compHTML = '<div class="comp"><div class="comp__top">'+
        '<h3>Es un dupe de '+esc(p.ins)+'</h3>'+
        '<p>Un <b>dupe</b> es un perfume que reproduce la firma de otro más caro por una fracción del precio. Este lo declara en su propia ficha, y el original también está en nuestra vitrina: aquí los tienes lado a lado, medidos por mililitro.</p>'+
      '</div><div class="comp__par">'+
        '<div class="comp__c"><img src="'+foto(p)+'" alt="'+esc(p.n)+'"><small>El dupe</small>'+
          '<strong>'+esc(p.n)+'</strong><b>'+clp(p.p)+'</b><small style="text-transform:none;letter-spacing:.02em">'+p.ml+' ml · '+clp(Math.round(e.mlA))+' el ml</small></div>'+
        '<div class="comp__mid">VS</div>'+
        '<a class="comp__c" href="'+url(o)+'"><img src="'+foto(o)+'" alt="'+esc(o.n)+'"><small>El original</small>'+
          '<strong>'+esc(o.n)+'</strong><b>'+clp(o.p)+'</b><small style="text-transform:none;letter-spacing:.02em">'+o.ml+' ml · '+clp(Math.round(e.mlB))+' el ml</small></a>'+
      '</div>'+
      '<div class="comp__pie"><span>Los dos en vitrina, hoy</span><span>El mililitro del dupe cuesta <b>'+e.pct+'% menos</b></span></div></div>';
  } else if (p.ins){
    // El original no está en vitrina. Va compacto, con el logotipo chico de la casa
    //   cuando lo tenemos: el nombre de la marca se reconoce mejor que leyéndolo.
    var casa = GP.logoDeTexto(p.ins);
    // si no tenemos el logotipo de la casa original, va la foto chica de este perfume:
    //   el hueco vacío se notaba más que cualquier otra cosa
    compHTML = '<div class="comp"><div class="comp__top comp__top--solo">'+
        (p.fo_orig
          ? '<img class="comp__logo comp__logo--frasco" src="'+p.fo_orig+'" alt="'+esc(p.ins)+'">'
          : (casa.url
            ? '<img class="comp__logo" src="'+casa.url+'" alt="'+esc(casa.marca)+'">'
            : (foto(p) ? '<img class="comp__logo comp__logo--foto" src="'+foto(p)+'" alt="'+esc(p.n)+'">' : '')))+
        '<div><h3>Es un dupe de '+esc(p.ins)+'</h3>'+
        '<p>Un <b>dupe</b> reproduce la firma de otro perfume más caro por una fracción del precio, y esta ficha lo declara. Ese original no está en nuestra vitrina hoy: '+
        '<a href="'+WAENC+'" target="_blank" rel="noopener">escríbenos y lo buscamos</a>.</p></div>'+
      '</div></div>';
  }

  /* ---------- pirámide ---------- */
  var capas = [['Salida', p.no.s, 'Los primeros minutos'],
               ['Corazón', p.no.c, 'Lo que se asienta a la hora'],
               ['Fondo', p.no.f, 'Lo que queda en la ropa']];
  var piramideHTML = (notas.length || p.dec) ? '<div class="piramide">'+
    '<div class="piramide__t"><h3>Cómo huele</h3>'+(notas.length?'<span>'+notas.length+' notas declaradas'+(p.f&&p.f.length?' · familia '+esc(p.f.join(', ').toLowerCase()):'')+'</span>':'')+'</div>'+
    (p.dec ? '<p class="piramide__dec">'+p.dec.replace(/<(?!\/?b>)/g,'&lt;')+'</p>' : '')+
    capas.filter(function(c){return c[1] && c[1].length;}).map(function(c){
      return '<div class="capa"><div class="capa__t">'+c[0]+'<small>'+c[2]+'</small></div>'+
        '<div class="notas">'+c[1].map(function(x){
          return '<a class="nota" href="'+GP.T({nota:x})+'">'+esc(x)+'</a>';}).join('')+'</div></div>';
    }).join('')+'</div>' : '';

  var sinStock = GP.agotadoP(p);
  var stockHTML = sinStock
    ? '<p class="pdp__stock agotado"><i></i>Sin stock por ahora · lo reponemos seguido</p>'
    : (p.st && p.st <= 5
      ? '<p class="pdp__stock bajo"><i></i>Quedan '+p.st+' unidades entre la web y el local</p>'
      : '<p class="pdp__stock"><i></i>Disponible · '+esc(GP.estadoLocal().retiro)+'</p>');

  // La explicación del tester va solo en las fichas de tester. En el resto sobra:
  //   el cliente la pidió fuera del bloque de autenticidad y en preguntas frecuentes.
  var ACOR = [];
  if (p.te) ACOR.push(['Qué es un tester','<p style="margin:0">Un tester es el frasco que la marca '+
    'reparte a las grandes tiendas para dar a oler la fragancia. Es el mismo perfume, la misma '+
    'concentración y el mismo frasco: cambia solo que viene en caja simple en vez de la caja de '+
    'regalo, y a veces sin tapa. Por eso cuesta menos.</p>']);
  var acorHTML = '<div class="acor">'+
    ACOR.concat([['Envío y retiro','<ul>'+
        '<li>Envío gratis en compras sobre '+clp(GP.UMBRAL)+' a todo Chile.</li>'+
        '<li>Región Metropolitana entre 24 y 72 horas hábiles.</li>'+
        '<li>Regiones entre 2 y 6 días hábiles.</li>'+
        '<li>Retiro sin costo en Av. Providencia 1336, Local 18.</li></ul>'],
     ['Autenticidad','<p style="margin:0">Trabajamos con distribuidores autorizados de cada marca en Chile. Por eso tenemos tienda física desde 2018: puedes venir, ver el producto y preguntar lo que quieras antes de comprar.</p>'],
     ['Cambios y devoluciones','<ul><li>Diez días corridos desde que recibes el pedido.</li>'+
        '<li>El producto tiene que venir sellado y sin uso.</li></ul>'],
     ['Formas de pago','<ul><li>Webpay con tarjetas de crédito y débito.</li>'+
        '<li>'+ GP.cuota(p.p) +' pagando con '+ GP.MEDIOS_CUOTAS.map(function(m){return m.n;}).join(' y ') +'.</li>'+
        '<li>Flow y transferencia bancaria.</li></ul>']
    ]).map(function(a,k){
      return '<div class="acor__it"><button class="acor__bt" type="button" aria-expanded="'+(k===0)+'" data-acor="'+k+'">'+a[0]+
        '<svg viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg></button>'+
        '<div class="acor__cu" id="acor'+k+'"'+(k===0?'':' hidden')+'>'+a[1]+'</div></div>';
    }).join('')+'</div>';

  var marcaLogo = GP.marcaLogo(p.b);

  $('#app').innerHTML =
  '<div class="pdp">'+
    '<div class="pdp__col pdp__col--fig"><div class="pdp__fig">'+ (foto(p)
      ? '<img src="'+foto(p)+'" alt="'+esc(p.n)+'" width="520" height="520">'
      : GP.sinFoto(p, true)) +
      '<div class="pdp__tools">'+
        '<button class="pdptool" type="button" data-fav="'+p.i+'" aria-label="Guardar en favoritos" title="Guardar">'+
          '<svg viewBox="0 0 24 24"><path d="M12 20s-7.5-4.6-7.5-9.4A4.1 4.1 0 0 1 12 7.6a4.1 4.1 0 0 1 7.5 3C19.5 15.4 12 20 12 20Z"/></svg></button>'+
        '<button class="pdptool" type="button" data-cmp="'+p.i+'" aria-label="Comparar" title="Comparar">'+
          '<svg viewBox="0 0 24 24"><path d="M4 7h7M4 12h7M4 17h7M16 5v14M13 8l3-3 3 3"/></svg></button>'+
      '</div></div></div>'+
    '<div class="pdp__col">'+
      (p.b ? '<p class="pdp__marca'+(marcaLogo?' pdp__marca--logo':'')+'">'+
        (marcaLogo ? '<img src="'+marcaLogo+'" alt="'+esc(p.b)+'">' : esc(p.b))+'</p>' : '')+
      '<h1>'+esc(p.n)+'</h1>'+
      '<div class="pdp__meta">'+
        (p.ml?'<span>'+p.ml+' ml</span>':'')+(p.t?'<span>'+esc(p.t)+'</span>':'')+
        (p.g?'<span>'+esc(p.g)+'</span>':'')+(p.te?'<span>Tester</span>':'')+
        '<span>SKU '+esc(p.sku)+'</span></div>'+
      '<div class="pdp__precio"><b>'+clp(p.p)+'</b>'+
        (p.ant&&p.ant>p.p?'<s>'+clp(p.ant)+'</s><em>−'+Math.floor(100*(1-p.p/p.ant))+'%</em>':'')+
        (p.ml?'<small>'+clp(Math.round(p.p/p.ml))+' el ml</small>':'')+'</div>'+
      // el bloque va bajo el precio en TODAS las fichas, con el cálculo hecho. La frase
      // termina en el logo —"pagando con [VentiPay]"—; si el logo no estuviera, se
      // completa con el nombre escrito para que la oración no quede colgando.
      (function(){
        var logos = GP.logosPago();
        var medios = GP.MEDIOS_CUOTAS.map(function(m){ return m.n; }).join(' y ');
        return '<div class="cuotas"><p class="cuotas__t">'+GP.cuota(p.p)+' pagando con'+
          (logos ? '' : ' '+medios)+'</p>'+logos+'</div>';
      })()+
      stockHTML + compHTML + envioHTML +
      (sinStock
        ? '<div class="pdp__agotado">'+GP.botonesAgotado(p, false)+'</div>'
        : '<div class="pdp__acciones">'+
            '<div class="cant"><button type="button" id="qm" aria-label="Menos">−</button><span id="qv">1</span><button type="button" id="qp" aria-label="Más">+</button></div>'+
            '<button class="btn btn--oro" style="flex:1" type="button" id="add">Agregar al carro</button>'+
          '</div>'+
          '<a class="btn btn--linea btn--bloque" style="margin-top:10px" target="_blank" rel="noopener" '+
            'href="https://api.whatsapp.com/send/?phone=56965529189&text='+encodeURIComponent('Hola, quiero consultar por '+p.n+' (SKU '+p.sku+')')+'">Consultar por WhatsApp</a>')+
      '<div class="pdp__extra">'+
        '<span><svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>Envío gratis: RM sobre '+clp(GP.UMBRAL)+' · regiones sobre '+clp(GP.UMBRAL_REGIONES)+'</span>'+
        '<span><svg viewBox="0 0 24 24"><path d="M4 10 12 4l8 6v9H4z"/><path d="M9 19v-5h6v5"/></svg>Retiro gratis en el local</span>'+
        '<span><svg viewBox="0 0 24 24"><path d="M12 3 4 6v6c0 4.5 3.4 8 8 9 4.6-1 8-4.5 8-9V6Z"/><path d="m9 12 2 2 4-4"/></svg>Original, distribuidor autorizado</span>'+
      '</div>'+ piramideHTML + acorHTML +
    '</div>'+
  '</div><div id="extras"></div>';

  var q = 1;
  if (!sinStock){
    $('#qm').addEventListener('click', function(){ q = Math.max(1,q-1); $('#qv').textContent = q; });
    $('#qp').addEventListener('click', function(){ q = Math.min(12,q+1); $('#qv').textContent = q; });
    $('#add').addEventListener('click', function(){ GP.agregar(p.i, q); });
  }
  var se = $('#sumarEnvio');
  if (se) se.addEventListener('click', function(){
    GP.agregar(p.i, q, true);
    sug.forEach(function(s){ GP.agregar(s.i, 1, true); });
    GP.abrirDrawer('carro');
  });

  /* ---------- extras ---------- */
  var MOTIVO = {probar:'También te puede gustar', pareja:'Para regalar en pareja', marca:'De la misma casa', familia:'Mismo aire olfativo'};
  var cruz = (GP.cross[p.i]||[]).map(function(c){ var x = IX[c.id]; return x && x.img ? {p:x, m:c.motivo} : null; }).filter(Boolean).slice(0,4);
  if (cruz.length < 4){
    (GP.sim[p.i]||[]).forEach(function(s){
      var x = IX[s.id];
      if (x && x.img && cruz.length<4 && !cruz.some(function(c){return c.p.i===x.i;})) cruz.push({p:x, m:'familia'});
    });
  }
  var sims = (GP.sim[p.i]||[]).map(function(s){ var x = IX[s.id]; return x ? {p:x, c:s.comunes} : null; })
              .filter(Boolean).filter(function(s){return s.c>=3;}).slice(0,4);
  var R = (GP.reviews||[]).slice(0,3);
  var html = '';

  if (cruz.length){
    html += '<section class="sec" style="padding-bottom:0"><div class="cabsec">'+
      '<div><p class="eyebrow">Se lleva bien con</p><h2 class="display" style="font-size:1.9rem">Lo que suele salir junto</h2></div></div>'+
      '<div class="grid">'+ cruz.map(function(c){
        return GP.card(c.p).replace('<div class="card__body">',
          '<div class="card__body"><span class="card__marca" style="color:var(--tinta-3)">'+esc(MOTIVO[c.m]||'También te puede gustar')+'</span>');
      }).join('') +'</div></section>';
  }

  if (sims.length){
    html += '<section class="sec" style="padding-bottom:0"><div class="cabsec">'+
      '<div><p class="eyebrow">Comparar</p><h2 class="display" style="font-size:1.9rem">Otros con las mismas notas</h2>'+
      '<p class="bajada">Calculado sobre las notas declaradas en cada ficha, no sobre la marca.</p></div>'+
      '<a class="enlace" href="/pages/comparador">Abrir el comparador →</a></div>'+
      '<div class="tabla-wrap"><table class="comp-t"><thead><tr>'+
        '<th>Fragancia</th><th>Notas en común</th><th>Familia</th><th>Tamaño</th><th>Precio</th><th>Por ml</th><th></th>'+
      '</tr></thead><tbody>'+
      '<tr class="actual"><td><div class="tp">'+(foto(p)?'<img src="'+foto(p)+'" alt="">':'')+
        '<div><strong>'+esc(p.n)+'</strong><span>Estás viendo</span></div></div></td>'+
        '<td>—</td><td>'+esc((p.f||[]).join(', ')||'—')+'</td><td>'+(p.ml?p.ml+' ml':'—')+'</td>'+
        '<td><b>'+clp(p.p)+'</b></td><td>'+(p.ml?clp(Math.round(p.p/p.ml)):'—')+'</td><td></td></tr>'+
      sims.map(function(s){
        var x = s.p;
        return '<tr><td><a href="'+url(x)+'"><div class="tp">'+(foto(x)?'<img src="'+foto(x)+'" alt="">':'')+
          '<div><strong>'+esc(x.n)+'</strong><span>'+esc(x.b||'')+'</span></div></div></a></td>'+
          '<td><b style="font-family:var(--sans);font-size:13px">'+s.c+'</b> de '+notas.length+'</td>'+
          '<td>'+esc((x.f||[]).join(', ')||'—')+'</td><td>'+(x.ml?x.ml+' ml':'—')+'</td>'+
          '<td><b>'+clp(x.p)+'</b></td><td>'+(x.ml?clp(Math.round(x.p/x.ml)):'—')+'</td>'+
          '<td><button class="mchip" type="button" data-cmp="'+x.i+'">Comparar</button></td></tr>';
      }).join('')+'</tbody></table></div></section>';
  }

  if (R.length){
    html += '<section class="sec" style="padding-bottom:0"><div class="cabsec"><div><p class="eyebrow">Opiniones</p>'+
      '<h2 class="display" style="font-size:1.9rem">Lo que dicen quienes ya compraron</h2></div></div>'+
      '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:14px">'+
      R.map(function(r){
        return '<article class="rev"><div class="rev__top"><strong>'+esc(r.n)+'</strong><span class="estrellas">'+'★'.repeat(r.r)+'</span></div>'+
          '<p>'+esc(r.t)+'</p><p class="rev__prod">Sobre '+esc(r.p)+'</p></article>';
      }).join('')+'</div></section>';
  }

  $('#extras').innerHTML = html;

  document.addEventListener('click', function(ev){
    var b = ev.target.closest('[data-acor]');
    if (!b) return;
    var cu = $('#acor'+b.getAttribute('data-acor'));
    var ab = b.getAttribute('aria-expanded')==='true';
    b.setAttribute('aria-expanded', !ab);
    cu.hidden = ab;
  });

  $('#atcIn').innerHTML = (foto(p)?'<img src="'+foto(p)+'" alt="">':'')+
    '<div class="atc__t"><strong>'+esc(p.n)+'</strong><span>'+clp(p.p)+(p.ml?' · '+p.ml+' ml':'')+'</span></div>'+
    (sinStock
      ? GP.botonAvisoFijo(p)
      : '<button class="btn btn--oro" type="button" id="addSticky">Agregar</button>');
  var bs = $('#addSticky');
  if (bs) bs.addEventListener('click', function(){ GP.agregar(p.i, q); });

  var atc = $('#atc');
  function vigilar(){
    var boton = $('#add') || document.querySelector('.pdp__agotado'),
        pie = document.querySelector('.pie'), cmp = $('#cmpbar');
    if (boton){
      var rb = boton.getBoundingClientRect();
      var rp = pie ? pie.getBoundingClientRect() : {top: 1e9};
      var tapado = cmp && !cmp.hidden;
      atc.classList.toggle('ver', rb.bottom < 0 && rp.top > window.innerHeight && !tapado);
    }
    requestAnimationFrame(vigilar);
  }

  GP.montar('');
  document.getElementById('extras').insertAdjacentHTML('beforeend', GP.bloqueVistos(p.i));
  requestAnimationFrame(vigilar);

  /* ---------- disponibilidad en vivo ----------
     El catálogo del tema es una foto que se genera y se sube. Entre medio, Syncron mueve
     el stock desde Bsale y la foto queda vieja: fichas que ofrecen algo agotado, y peor,
     fichas que dicen "sin stock" de algo que sí hay. Acá se pregunta por la verdad
     (/products/<handle>.js devuelve `available` en vivo) y se corrige solo el botón, sin
     volver a pintar la ficha, para no desarmar lo que ya quedó enganchado. */
  (function disponibilidadReal(){
    if (!GP.handleActual || !window.fetch) return;

    fetch('/products/' + GP.handleActual + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var v = d && d.variants && d.variants[0];
        if (!v) return;
        var hayAhora = !!v.available;
        var decíaLaFoto = !sinStock;   // lo que dijo la foto al pintar la ficha
        if (hayAhora === decíaLaFoto) return;

        var acciones = document.querySelector('.pdp__acciones');
        var agotado = document.querySelector('.pdp__agotado');

        if (!hayAhora && acciones) {
          acciones.innerHTML = '<p class="pdp__aviso-stock">Se acaba de agotar mientras mirabas la ficha.</p>';
          acciones.insertAdjacentHTML('afterend', '<div class="pdp__agotado">' + GP.botonesAgotado(p, false) + '</div>');
          var sticky = document.getElementById('atcIn');
          if (sticky) sticky.innerHTML = '';
          return;
        }

        if (hayAhora && agotado) {
          agotado.innerHTML =
            '<p class="pdp__aviso-stock">Volvió a haber stock.</p>' +
            '<button class="btn btn--oro btn--bloque" type="button" id="addVivo">Agregar al carro</button>';
          document.getElementById('addVivo').addEventListener('click', function () { GP.agregar(p.i, 1); });
        }
      })
      .catch(function () { /* si la consulta falla, se queda lo que decía la foto */ });
  })();
})();